export default __webpack_public_path__ + "img/844d74fb167a4265c1bf1d604097a3f3.svg";